<template>
  <div class="modal-image-inspector">
    <div v-if="options.images.length > 1" class="modal-image-inspector__thumbnails">
      <button
        v-for="(image, index) in options.images"
        :key="image.imageId"
        class="modal-image-inspector__thumbnail"
        :class="{ 'modal-image-inspector__thumbnail--active': index === options.displayIndex }"
        :aria-label="`View image ${index + 1}`"
        @click="options.displayIndex = index">
        <img :src="`${image.url}?preset=ProductSmall&watermark=OIEWatermarkSmall`" :alt="`Thumbnail ${index + 1}`" class="modal-image-inspector__thumbnail-image">
      </button>
    </div>

    <div class="modal-image-inspector__image-container">
      <oie-base-action
        v-if="!disablePrev"
        theme="outlined-black"
        class="modal-image-inspector__button modal-image-inspector__button--left"
        aria-label="See previous image"
        round
        @click="options.displayIndex--">
        <oie-base-icon icon="chevron-left"></oie-base-icon>
      </oie-base-action>
      <oie-base-action
        v-if="!disableNext"

        theme="outlined-black"
        class="modal-image-inspector__button modal-image-inspector__button--right"
        aria-label="See next image"
        round
        @click="options.displayIndex++">
        <oie-base-icon icon="chevron-right"></oie-base-icon>
      </oie-base-action>

      <vehicle-selector-function-info-interactive-map
        v-if="options.images[options.displayIndex].data && !isMobile"
        :media-assets-data="[options.images[options.displayIndex].data]"
        :media-assets-url="[options.images[options.displayIndex].url]"
        :selected-image-index="0"
        :magnification="true"
        :products="options.products"
        :id-prefix="`modal-inspector-${options.displayIndex}`">
      </vehicle-selector-function-info-interactive-map>
      <img
        v-else
        :src="`${options.images[options.displayIndex].url}`"
        alt="Machine image"
        class="modal-image-inspector__image">
    </div>
  </div>
</template>

<script>
import VehicleSelectorFunctionInfoInteractiveMap from './vehicle-selector/vehicle-selector-function-info-interactive-map.vue'

export default {
  components: { VehicleSelectorFunctionInfoInteractiveMap },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isMobile: window.matchMedia('(max-width: 650px)').matches
    }
  },
  computed: {
    disablePrev() {
      return this.options.displayIndex === 0
    },
    disableNext() {
      return this.options.displayIndex + 1 === this.options.images.length
    }
  },
  created() {
    this._mediaQuery = window.matchMedia('(max-width: 650px)')
  },
  mounted() {
    this._onMediaQueryChange = (e) => { this.isMobile = e.matches }
    this._mediaQuery.addEventListener('change', this._onMediaQueryChange)
  },

  beforeDestroy() {
    this._mediaQuery.removeEventListener('change', this._onMediaQueryChange)
  }
}
</script>

<style lang="scss">
.modal-image-inspector {
  display: flex;
  flex-direction: column;
}

.modal-image-inspector__image-container {
  position: relative;
}

.modal-image-inspector__image {
  width: 100%;
  height: auto;
}

.modal-image-inspector__button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.modal-image-inspector__button--left {
  left: -5px;
}

.modal-image-inspector__button--right {
  right: -5px;
}

.modal-image-inspector__thumbnails {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: measure(quarter);
  margin-bottom: measure(quarter);
  padding: measure(quarter);
}

.modal-image-inspector__thumbnail {
  @include reset-button;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: rgba(0, 0, 0, 0.3);
  }

  &--active {
    border-color: #0066A1;
  }
}

.modal-image-inspector__thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
